import React from 'react'
import {RPCDocs} from '@therms/rpc-gateway'
import {Icon} from '@therms/atalaya'
import {DateTime} from '@therms/react-modules'
import {MdComment} from 'react-icons/md'
import classNames from 'classnames'
import Status = RPCDocs.Locations.GetLocationTaskCompletions.v1.Status

interface LocationTaskCompletionListCardProps {
  hideDetails?: boolean
  hideTitle?: boolean
  locationTaskCompletion: RPCDocs.Locations.GetLocationTaskCompletions.v1.LocationTaskCompletion
}

export function LocationTaskCompletionListCard({
  hideDetails,
  locationTaskCompletion: completion,
}: LocationTaskCompletionListCardProps) {
  return (
    <div
      className={classNames(
        {
          'border-caution': completion.status === Status.Skipped,
          'border-critical': completion.status === Status.Missed,
          'border-positive': completion.status === Status.Completed,
        },
        'p-sm border-l-2',
      )}
    >
      {!hideDetails && (
        <div>
          <span className="text-color-strong text-md font-medium">
            {completion.title}
          </span>

          {!!completion.description && <span>, {completion.description}</span>}
        </div>
      )}

      <div className={classNames({'mt-xs': !hideDetails})}>
        <span
          className={classNames(
            {
              'text-color-caution': completion.status === Status.Skipped,
              'text-color-critical': completion.status === Status.Missed,
              'text-color-positive': completion.status === Status.Completed,
            },
            'font-bold capitalize',
          )}
        >
          {completion.status}
        </span>

        <span className="text-color-subtle"> at </span>

        <span className="font-medium">
          <DateTime timestamp={completion.statusDate} />
        </span>

        {!!completion.dueDate && (
          <span className="text-color-subtle">
            {' '}
            (<span className="text-color-subtle">Due</span>{' '}
            <DateTime timestamp={completion.dueDate} shortFormat />)
          </span>
        )}
      </div>

      {completion.note && (
        <div className="mt-sm pt-sm border-border border-t text-sm">
          <Icon
            className="mr-xs text-color-subtle"
            Icon={MdComment}
            size="sm"
          />
          <span className="">{completion.note}</span>
        </div>
      )}
    </div>
  )
}
